import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Drawer, List, ListItem, ListItemText, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../assets/logo_footer.png';

const pages = [
  { name: "Accueil", url: "/home" },
  { name: "Nos conseils", url: "/advice" },
  { name: "L’équipe", url: "/team" },
  { name: "Articles", url: "/articles" },
  { name: "A propos", url: "/about" },
  { name: "Nous contacter", url: "/contact" }
];

const Nav = ({ bg }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <AppBar
      position="fixed"
      style={{
        backgroundColor: scrolled ? '#000' : bg,
        padding: isMobile ? '0 2em' : '2em 3em 0em 3em',
        transition: 'background-color 0.5s ease',
        border: 'none',
      }}
      elevation={scrolled ? 4 : 0}
    >
      <Toolbar style={{ justifyContent: 'space-between' }}>
        <div style={{ height: '50px' }}>
          <img src={logo} alt="Logo" style={{ height: '100%' }} />
        </div>

        {isMobile ? (
          <>
            <IconButton edge="end" color="inherit" onClick={toggleDrawer(true)} style={{ color: '#00e5ff' }}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
              <List>
                {pages.map((page, index) => (
                  <ListItem button key={index} component={Link} to={page.url} onClick={toggleDrawer(false)}>
                    <ListItemText primary={page.name} />
                  </ListItem>
                ))}
                <ListItem button component={Link} to="/inscription" onClick={toggleDrawer(false)}>
                  <ListItemText primary="INSCRIPTION" />
                </ListItem>
              </List>
            </Drawer>
          </>
        ) : (
          <>
            <ul style={{
              display: 'flex',
              listStyle: 'none',
              gap: '30px',
              margin: '0',
              padding: '0'
            }}>
              {pages.map((page, index) => (
                <li key={index}>
                  <Link to={page.url} style={{ color: '#fff', textDecoration: 'none', fontSize: '18px' }}>
                    {page.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div>
              <Link to="/inscription" style={{
                padding: '10px 20px',
                backgroundColor: '#00e5ff',
                color: '#000',
                borderRadius: '5px',
                textDecoration: 'none',
                fontWeight: 'bold'
              }}>
                INSCRIPTION
              </Link>
            </div>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Nav;
